import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=890005cc&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "890005cc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('890005cc')) {
      api.createRecord('890005cc', component.options)
    } else {
      api.reload('890005cc', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=890005cc&scoped=true&", function () {
      api.rerender('890005cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2IXr1IdiIpoHs/JS/comp/SearchFilterTokens.vue"
export default component.exports